import { BaseService } from "@kiddocare-platform/portal-common/base";

export class RepositoryFamilyService extends BaseService {

  public async UploadAttachment(idEvent: bigint | string, name: string, media: Blob): Promise<unknown> {
    try {
      const formData = new FormData();
      formData.append("media", media, name);
      const response = await this.AxiosInstance.post(`/parent/family/uploadAttachment/${idEvent}/${encodeURIComponent(name)}`, formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      },
      );

      return response.data;
    } catch (error: any) {
      throw error;
    }
  }


  public async GetAttachment(idEvent: bigint | string, key: string): Promise<Blob> {
    try {
      const response = await this.AxiosInstance.get(`/parent/family/attachment/${idEvent}/${encodeURIComponent(key)}`, {
        responseType: "blob",
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  public async DeleteAttachment(idEvent: bigint | string, key: string): Promise<unknown> {
    try {
      const response = await this.AxiosInstance.delete(`/parent/family/attachment/${idEvent}/${encodeURIComponent(key)}`, {
        responseType: "blob",
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
}
